import './styles.scss'
import bubble from '../bubble';
import { globalData } from '../..';
import { ID_NAMES } from '../../env';
import chat from '../chat';

const layout = () => {

    const layout = document.createElement("div");
    layout.id = ID_NAMES.LAYOUT

    document.body.append(layout)

    bubble()
    chat()

}

export default layout